export function shouldShowPurchaseBar({ mobile, buttonBottoms }) {
  return mobile && buttonBottoms.length > 0 && buttonBottoms.every(bottom => bottom <= 0);
}

if (typeof customElements !== 'undefined' && !customElements.get('ombre-mobile-purchase')) {
  customElements.define('ombre-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-ombre-native-product-detail]');
      this.form = this.root?.querySelector('.onpd__form');
      this.mainButton = this.root?.querySelector('[data-ombre-add-button]');
      if (!this.form || !this.mainButton) return;
      this.button = this.querySelector('[data-onpd-mobile-add]');
      this.buyButton = this.querySelector('[data-onpd-mobile-buy]');
      this.sourceBuy = this.root.querySelector('[data-ombre-buy-now]');
      this.image = this.querySelector('[data-onpd-mobile-image]');
      this.variantLabel = this.querySelector('[data-onpd-mobile-variant]');
      this.variants = JSON.parse(this.root.querySelector('[data-ombre-variant-data]').textContent);
      this.price = this.querySelector('[data-onpd-mobile-price]');
      this.sourcePrice = this.root.querySelector('[data-ombre-price]');
      this.sourceLabel = this.mainButton.querySelector('[data-ombre-add-label]');
      this.originalButtons = [this.mainButton, this.sourceBuy].filter(Boolean);
      this.media = window.matchMedia('(max-width: 749px)');
      this.reviews = this.root.querySelector('[data-onpd-reviews]');
      this.reviewLink = this.root.querySelector('[data-onpd-mobile-review-link]');
      this.onScroll = () => this.updateVisibility();
      this.onChange = () => this.sync();
      this.onClick = () => {
        if (!this.button.disabled) this.mainButton.click();
      };
      this.onBuyClick = () => {
        if (!this.buyButton.disabled) this.sourceBuy?.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.buyButton.addEventListener('click', this.onBuyClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.media.addEventListener('change', this.onScroll);
      this.observer = new MutationObserver(this.onChange);
      this.observer.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      if (this.sourceBuy) this.observer.observe(this.sourceBuy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.observer.observe(this.root, { attributes: true, attributeFilter: ['data-selected-variant-id'] });
      this.observer.observe(this.form, { attributes: true, attributeFilter: ['data-cart-drawer-adding'] });
      if (this.sourcePrice) this.observer.observe(this.sourcePrice, { childList: true, subtree: true, characterData: true });
      if (this.reviews) this.observer.observe(this.reviews, { attributes: true, attributeFilter: ['data-mobile-review-count', 'data-mobile-review-rating'] });
      this.intersection = new IntersectionObserver(this.onScroll);
      this.originalButtons.forEach(button => this.intersection.observe(button));
      this.sync();
    }

    updateVisibility() {
      this.hidden = !shouldShowPurchaseBar({
        mobile: this.media.matches,
        buttonBottoms: this.originalButtons.map(button => button.getBoundingClientRect().bottom),
      });
      document.body.classList.toggle('onpd-mobile-purchase-active', !this.hidden);
    }

    sync() {
      this.price.textContent = this.sourcePrice?.textContent.trim() || '';
      const adding = this.form.dataset.cartDrawerAdding === 'true';
      const checkingOut = this.sourceBuy?.disabled && !this.mainButton.disabled;
      const busy = adding || checkingOut;
      this.button.disabled = busy || this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.textContent = adding ? 'Adding…' : (this.sourceLabel?.textContent.trim() || this.mainButton.textContent.trim());
      this.buyButton.disabled = busy || this.mainButton.disabled || !this.sourceBuy || this.sourceBuy.disabled || this.sourceBuy.getAttribute('aria-disabled') === 'true';
      this.buyButton.textContent = checkingOut ? 'Opening…' : (this.sourceBuy?.textContent.trim() || 'Buy Now');
      const variant = this.variants.find(item => String(item.id) === this.root.dataset.selectedVariantId);
      let imageSource = this.image?.dataset.fallbackSrc;
      if (variant?.featured_image?.src) {
        const thumbnailUrl = new URL(variant.featured_image.src, window.location.href);
        thumbnailUrl.searchParams.set('width', '120');
        imageSource = thumbnailUrl.href;
      }
      if (this.image && imageSource && this.image.getAttribute('src') !== imageSource) this.image.setAttribute('src', imageSource);
      if (this.variantLabel) {
        this.variantLabel.textContent = variant?.title === 'Default Title' ? '' : (variant?.title || '');
        this.variantLabel.hidden = !this.variantLabel.textContent;
      }
      if (this.reviewLink && this.reviews) {
        const count = Number(this.reviews.dataset.mobileReviewCount);
        const rating = Number(this.reviews.dataset.mobileReviewRating);
        this.reviewLink.hidden = !(count > 0 && rating > 0 && this.reviews.dataset.reviewScope === 'current_product');
        if (!this.reviewLink.hidden) {
          const label = this.reviews.dataset.reviewCountLabel === 'Ratings' ? 'ratings' : 'reviews';
          this.reviewLink.textContent = `★ ${rating.toFixed(1)} · ${count} ${label}`;
          this.reviewLink.href = `#${this.reviews.id}`;
        }
      }
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.media?.removeEventListener('change', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
      this.buyButton?.removeEventListener('click', this.onBuyClick);
      document.body.classList.remove('onpd-mobile-purchase-active');
    }
  });
}
